var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Breadcrumb',_vm._l((_vm.currentPath),function(item,index){return _c('BreadcrumbItem',{key:index,attrs:{"to":item.path}},[_c('Icon',{attrs:{"type":item.meta.icon}}),_vm._v(_vm._s(_vm.itemTitle(item)))],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }